import { render } from "./DeleteProduct.vue?vue&type=template&id=f863429e&scoped=true"
import script from "./DeleteProduct.vue?vue&type=script&lang=js"
export * from "./DeleteProduct.vue?vue&type=script&lang=js"

import "./DeleteProduct.vue?vue&type=style&index=0&id=f863429e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f863429e"]])

export default __exports__